import staticPath from 'framework/filters/static-path';

export const ARCOBALENO = 'arcobaleno';
export const SOSICLES = 'sosicles';
export const LOPIERD = 'lopierd';
export const WHAT_IS_LOVE = 'what is love';

export const IMAGES = {
    [SOSICLES]: staticPath('img/easter-eggs/sosicles.jpg'),
    [LOPIERD]: staticPath('img/easter-eggs/lopierd.gif'),
};
export const eggs = [ARCOBALENO, SOSICLES, LOPIERD, WHAT_IS_LOVE];
